import { CAppusers, CCredential } from "./../app-services/system-interface";
import { Component, OnInit } from "@angular/core";
import { GetDataService } from "./../app-services/manage-data.service";
import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material";
import { Inject } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";

export interface DialogData {
  message: "erro";
  messageId: 0;
}

@Component({
  selector: "app-dashboard",
  templateUrl: "login.component.html",
})
@Injectable()
export class LoginComponent implements OnInit {
  public cCredential = new CCredential();
  public userLoggedIn: CAppusers[] = new Array<CAppusers>();
  public messageAlert: string;

  constructor(private dataServer: GetDataService, public dialog: MatDialog) {}

  openDialog1() {
    this.dialog.open(DialogElementsDialog, {
      data: {
        message: "Info App Message",
      },
    });
  }

  ngOnInit() {}

  loginAppusers(sender) {
    this.dataServer.doLoginAppusers("user", this.cCredential).subscribe(
      (data) => {
        // console.log("this is resond data");
        // console.log(data);
        if (data != "Not Allowed" && data != "Not Record Found") {
          sessionStorage.setItem("userDetails", JSON.stringify(data));
          window.location.href = "#/lawyerlinkmenu";
        } else {
          this.messageAlert = "Invalid username or password. " + "Try again";
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }
}

@Component({
  selector: "dialog-elements-dialog",
  templateUrl: "infomessage.html",
})
export class DialogElementsDialog {
  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData) {}
}
